import { render, staticRenderFns } from "./MoveButton.vue?vue&type=template&id=d0837dc8&scoped=true&"
import script from "./MoveButton.vue?vue&type=script&lang=ts&"
export * from "./MoveButton.vue?vue&type=script&lang=ts&"
import style0 from "./MoveButton.vue?vue&type=style&index=0&id=d0837dc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0837dc8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VHover,VIcon})
